import { toast } from "react-hot-toast";
import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import { replaceAll, uppercaseFirstLetter } from "~/utils";
import { getAuthToken, setToken } from "../helpers/authUtils";

const request = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 100000000,
});

export const requestNoToast = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 100000,
});

requestNoToast.interceptors.request.use((config) => {
  if (!config.headers) {
    config.headers = {};
  }

  const token = getAuthToken();
  // console.log("getAuthToken, ", token);
  if (token.access) {
    config.headers["Accept-Language"] = `id-ID`;
    config.headers["Authorization"] = `Bearer ${token.access}`;
  }
  return config;
});

requestNoToast.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    return Promise.reject(err);
  }
);

request.interceptors.request.use((config) => {
  if (!config.headers) {
    config.headers = {};
  }

  const token = getAuthToken();
  if (token?.access) {
    config.headers["Authorization"] = `Bearer ${token.access}`;
  }

  return config;
});

request.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    const responseRequest = err.response.data;
    const notoast = err.config?.env?.notoast ?? false;

    const errorStatus = [400, 401, 403];

    if (
      !notoast &&
      errorStatus.includes(err.response.status) &&
      Array.isArray(responseRequest?.errors)
    ) {
      var arrayErrorMessage = responseRequest?.errors;

      if (
        arrayErrorMessage?.[0] !== "Given token not valid for any token type" &&
        arrayErrorMessage?.[0] !==
          "Token yang diberikan tidak valid untuk semua jenis token"
      ) {
        let errorStatusValidation = [];

        arrayErrorMessage.map((elem) =>
          typeof elem === "string"
            ? errorStatusValidation.push(elem)
            : Object.entries(elem).map(([key, value]) => {
                if (Array.isArray(value)) {
                  errorStatusValidation.push({
                    [key]: value.join(),
                  });
                } else {
                }
              })
        );

        errorStatusValidation.forEach((errorMessage) => {
          if (typeof errorMessage === "string") {
            toast.error(errorMessage);
          } else {
            Object.entries(errorMessage).map(([key, value]) =>
              toast.error(
                `${uppercaseFirstLetter(replaceAll(key, "_", " "))}: ${value}`,
                {
                  duration: 9000,
                }
              )
            );
          }
        });
      }
    }
    // else {
    //   toast.error(
    //     "Maaf Server Kami Sedang bermasalah, Silakan coba lagi nanti !"
    //   );

    //   return Promise.reject(err);
    // }

    // retrurn err;
    return Promise.reject(err);
  }
);

const refreshAuthLogic = (failedRequest) => {
  return new Promise((resolve, reject) => {
    request
      .post("/v1/token/refresh/", {
        refresh: getAuthToken().refresh,
      })
      .then((tokenResponse) => {
        const newToken = tokenResponse.data;
        setToken(newToken);
        failedRequest.response.config.headers[
          "Authorization"
        ] = `Bearer ${newToken}`;

        resolve();
      })
      .catch(() => {
        setToken(null);
        window.location.replace("/user/account/login");
        reject();
      });
  });
};

export const requestDownload = (url, filename = "Download") => {
  return request.get(url, { responseType: "arraybuffer" }).then((response) => {
    const type = response.headers["content-type"];
    const blob = new Blob([response.data], { type, encoding: "UTF-8" });
    let name = filename;
    const disposition = response.headers["content-disposition"];
    if (disposition && disposition.indexOf("inline") !== -1) {
      const filenameregex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameregex.exec(disposition);
      if (matches !== null && matches[1]) {
        name = matches[1].replace(/['"]/g, "");
      }
    }

    const URL = window.URL || window.webkitURL;
    const donwloadurl = URL.createObjectURL(blob);

    const iOS =
      window.navigator.platform &&
      /iPad|iPhone|iPod/.test(window.navigator.platform);
    if (iOS) {
      const reader = new FileReader();
      reader.onload = function (e) {
        let newWindow = window.open(reader.result);
        newWindow.onload = function () {
          newWindow.document
            .getElementsByTagName("html")[0]
            .appendChild(document.createElement("head"))
            .appendChild(document.createElement("title"))
            .appendChild(document.createTextNode("name"));
        };

        setTimeout(() => {
          newWindow.document.title = name;
        }, 100);
      };
      reader.readAsDataURL(blob);
    } else {
      const link = document.createElement("a");
      link.href = donwloadurl;
      link.target = "_blank";
      link.click();
      setTimeout(() => {
        link.remove();
      }, 1500);
    }

    return Promise.resolve(true);
  });
};
export default request;

createAuthRefreshInterceptor(request, refreshAuthLogic, {
  statusCodes: [401],
  pauseInstanceWhileRefreshing: true,
  interceptNetworkError: true,
});
